/**
 * Proposal List/Management Page
 * Unified page for viewing proposals and generating new ones
 * Uses enhanced ComplianceReports component with RFP-specific filtering and quick actions
 */

import React, { useEffect, useState } from 'react';
import { ComplianceReports } from '../components/ComplianceReports';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { useToastStore } from '@tracekit/core';

export function ProposalListPage() {
  const { addToast } = useToastStore();
  const [initialReportId, setInitialReportId] = useState<string | undefined>(undefined);
  
  // Check for reportId or proposal_id in URL query params
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const reportId = urlParams.get('reportId') || urlParams.get('proposal_id');
    
    if (reportId) {
      // Set initial report ID to open it in viewer
      setInitialReportId(reportId);
      
      // Clean up reportId param but keep proposal_id
      if (urlParams.get('reportId')) {
        setTimeout(() => {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.delete('reportId');
          window.history.replaceState({}, '', newUrl.toString());
        }, 100);
      }
    }
  }, []);

  return (
    <div>
      <Breadcrumbs items={[{ label: 'RFP Proposals' }]} />
      <ComplianceReports initialReportId={initialReportId} />
    </div>
  );
}
